export const HOST_DATE_RANGE_PRESETS = ['today', 'last7d', 'last30d', 'last90d'] as const;
export type HostDateRangePreset = (typeof HOST_DATE_RANGE_PRESETS)[number];
